<template>
  <div class="footer">
    <div class="bdbtm">
      <div class="m">
        <div class="footer_main">
          <div class="footer_main_l">
            <dl class="footer_nav">
              <dt>
                <a>关于我们</a>
              </dt>
              <dd>
                <a href="https://www.sctcc.cn/#/about_us/recruit" target="_blank">招贤纳士</a>
              </dd>
              <dd>
                <a href="https://www.sctcc.cn/#/wiki" target="_blank">华转百科</a>
              </dd>
              <dd>
                <a href="https://www.sctcc.cn/#/about_us/news" target="_blank">企业新闻</a>
              </dd>
            </dl>
            <dl class="footer_nav">
              <dt>
                <a>平台服务</a>
              </dt>
              <!-- <dd>
                <router-link to="/user_agreement">用户协议</router-link>
              </dd>
              <dd>
                <router-link to="/privacy_statement">隐私声明</router-link>
              </dd> -->
              <dd>
                <a href="https://www.sctcc.cn/#/about_us/agreement/user_protocol" target="_blank">用户协议</a>
              </dd>
              <dd>
                <a href="https://www.sctcc.cn/#/about_us/agreement/privacy_clauset" target="_blank">隐私声明</a>
              </dd>
            </dl>
            <dl class="footer_nav">
              <dt>
                <a href="#/help_center/faq" target="_blank">帮助中心</a>
              </dt>
              <dd>
                <a href="https://www.sctcc.cn/#/help_center/faq?type=ActiveTypeHelpGDInnovate" target="_blank">创新券</a>
              </dd>
              <dd>
                <a href="https://www.sctcc.cn/#/help_center/faq?type=ActiveTypeMall" target="_blank">科技Mall</a>
              </dd>
              <dd><a href="https://www.sctcc.cn/#/help_center/faq?type=ActiveTypeHelpTechnologyCommissioner" target="_blank">企业科技特派员</a></dd>
            </dl>
            <dl class="footer_nav">
              <dt>
                <a>联系我们</a>
              </dt>
              <dd>
                <a>020-39075666</a>
              </dd>
              <dd>
                <a style="white-space:nowrap" alt="广州市南沙区环市大道南25号（华南技术转移中心总部大楼）">广州市南沙区环市大道南25号（华南技术转移中心总部大楼）</a>
              </dd>
            </dl>
          </div>
          <div class="footer_main_r">
            <!-- <div>
                            <img :src="imgUrl.official"/>
                            <p>官方微信</p>
                        </div>
                        <div>
                            <img :src="imgUrl.customer_service"/>
                            <p>客服小助手</p>
            </div>-->
            <div @mouseenter="show_index = 0" @mouseleave="show_index=-1">
              <template v-if="show_index===0">
                <img src="../assets/img/common/weixin2.png" alt />
                <div class="er_code">
                  <img :src="imgUrl.official" alt />
                </div>
              </template>
              <template v-else>
                <img src="../assets/img/common/weixin1.png" alt />
              </template>
            </div>
            <div @mouseenter="show_index = 1" @mouseleave="show_index=-1">
              <template v-if="show_index===1">
                <a
                  href="https://www.zhihu.com/org/hua-nan-ji-zhu-zhuan-yi-zhong-xin/activities"
                  target="_blank"
                >
                  <img src="../assets/img/common/zhihu2.png" alt />
                  <div class="er_code">
                    <img src="../assets/img/common/zhihu_code.png" alt />
                  </div>
                </a>
              </template>
              <template v-else>
                <img src="../assets/img/common/zhihu1.png" alt />
              </template>
            </div>
            <div @mouseenter="show_index = 2" @mouseleave="show_index=-1">
              <template v-if="show_index===2">
                <a
                  href="https://h5.weishi.qq.com/weishi/personal/1575342982551398/wspersonal"
                  target="_blank"
                >
                  <img src="../assets/img/common/weishi2.png" alt />
                  <div class="er_code">
                    <img src="../assets/img/common/weishi_code.png" alt />
                  </div>
                </a>
              </template>
              <template v-else>
                <img src="../assets/img/common/weishi1.png" alt />
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="m">
      <div class="footer_bottom">
        <dl>
          <dt>
            <a>友情链接：</a>
          </dt>
          <dd>
            <a href="http://gdstc.gd.gov.cn/" target="_blank">广东省科技厅</a>
          </dd>
          <dd>
            <a href="http://www.gdppnet.com/" target="_blank">广东省生产力</a>
          </dd>
          <dd>
            <a href="http://www.gzsi.gov.cn/" target="_blank">广州市科技局</a>
          </dd>
          <dd>
            <a href="http://www.gzns.gov.cn/" target="_blank">南沙区政府</a>
          </dd>
          <dd>
            <a href="http://www.gdsoftpark.com" target="_blank">拓思软件园</a>
          </dd>
          <dd>
            <a href="http://gz.gemas.com.cn/" target="_blank">广交所集团</a>
          </dd>
          <dd>
            <a href="http://gnii.com.cn/" target="_blank">南沙产投</a>
          </dd>
          <dd>
            <a href="http://www.gzpc.org.cn/" target="_blank">广州生产力</a>
          </dd>
          <dd class="last">
            <a href="https://inno.emsd.gov.hk" target="_blank">香港创新科技协作平台</a>
          </dd>
        </dl>
        <div class="footer_bottom_banquan">
          版权所有：广东省华南技术转移中心有限公司&nbsp;&nbsp;&nbsp;&nbsp;
          <a
            href="http://beian.miit.gov.cn"
            target="_blank"
          >粤ICP备18077262号</a>
          <!-- <div style="padding: 0 10px">
            <a
              target="_blank"
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44011502000433"
              style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"
            >
              <img :src="imgUrl.anbei" style="float:left;width: 20px;height: 20px;" />
              <p
                style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"
              >粤公网安备 44011502000433号</p>
            </a>
          </div> -->
        </div>
      </div>
    </div>

 
  </div>
</template>

<script>
import official from "@/assets/img/erweima/official.jpg";
import customer_service from "@/assets/img/erweima/customer_service.png";
import anbei from "@/assets/img/icon/anbei.png";
export default {
  components: {
   
  },
  data() {
    return {
      imgUrl: {
        official,
        customer_service,
        anbei: anbei
      },
      show_index: -1
    };
  },
  methods: {}
};
</script>

<style lang="scss">
.footer {
  .bdbtm {
    border-bottom: 1px solid #45494b;
  }
  background: #292c2d;
  .footer_main {
    flex: 1;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 18px 0 10px;
  }
  .footer_main_l {
    display: flex;
    justify-content: flex-start;
    flex-direction: row;
  }
  .footer_nav {
    margin-right: 96px;
    dt {
      height: 34px;
      line-height: 34px;
      a {
        font-size: 14px;
        color: #e4edee;
      }
      margin-bottom: 25px;
      text-align: left;
    }
    dd {
      height: 30px;
      line-height: 30px;
      text-align: left;
      a {
        font-size: 14px;
        color: #80858c;
      }
    }
  }
  .footer_main_r {
    display: flex;
    // width: 300px;
    div {
      margin-left: -35px;
      text-align: center;
      cursor: pointer;
      width: 96px;
      img {
        width: 30px;
        height: 30px;
      }
      .er_code {
        margin: 0;
        position: relative;
        margin-top: 15px;
        z-index: 1;
        img {
          width: 96px;
          height: 96px;
          display: block;
          margin: 0 auto;
        }
      }
      .er_code::before {
        content: "";
        display: block;
        width: 30px;
        height: 30px;
        background: #fff;
        position: absolute;
        top: -1px;
        left: 50%;
        transform: translate3d(-50%, 0, 0) rotateZ(45deg);
        z-index: -100;
      }
      p {
        height: 34px;
        line-height: 34px;
        font-size: 14px;
        color: #e4edee;
        text-align: center;
      }
    }
  }
  .footer_bottom {
    font-size: 14px;
    padding: 24px 0 28px;

    dl {
      display: flex;
      a {
        color: #858d8e;
      }
    }
    dd {
      padding: 0 10px;
      border-right: 1px solid #45494b;
    }
    dd.last {
      border: 0;
    }
    .footer_bottom_banquan {
      margin-top: 26px;
      display: flex;
      align-items: center;
      /*text-align: center;*/
      justify-content: center;
      color: #858d8e;
      a {
        color: #858d8e;
      }
    }
  }
}
</style>
